/**
 * Central place for every Piano‑related constant.
 */

export const PIANO_ENV = process.env.NEXT_PUBLIC_PIANO_ENV ?? 'sandbox';

export const PIANO_URI = PIANO_ENV === 'prod'
  ? '//c2.piano.io'
  : '//sandbox.piano.io'; // potentially add /xbuilder/experience/ to the easier build the script url

export const PIANO_AID = Object.freeze({
  sandbox: {
    today: 'A0KIwP3zsu',
    news: 't4pUXPo5su',
  },
  prod: {
    // today: 'some aid',
  },
});


/**
 * Retrieves the piano aid configuration for a given environment and brand.
 * @param {string} env - The environment key (e.g., "sandbox" or "prod").
 * @param {string} brand - The brand key (e.g., "today").
 * @returns {string|null} The piano aid configuration if found, otherwise null.
 */
export const getPianoAid = (env, brand) => (PIANO_AID[env] && PIANO_AID[env][brand]) ?? null;

export const pianoContainerID = {
  FULL_WIDTH: 'piano-full-width',
  INLINE: 'piano-inline',
  FORM_TITLE: 'piano-form-title',
};
